import styled from 'styled-components';
import { colors } from '../colors';

interface ToastProps {
	right?: string;
	left?: string;
	top?: string;
	bottom?: string;
	show?: boolean;
	iconToast?: boolean;
	messageType?: string;
	toastBorder?: boolean;
}

const handleColorType = (type: string) => {
	switch (type) {
		case 'Success':
			return `border:1px solid #5AD17B;
                    border-left:5px solid #5AD17B;
                    > span{
                        color: #5AD17B;
                        font-size: 20px;
                    }
                `;
		case 'Error':
			return `border:1px solid #FD4848;
                    border-left:5px solid #FD4848;
					word-break: break-all;
                    > span{
						word-break: break-all;
                        color: white;
                        font-size: 20px;
                    }
                `;
		case 'Warning':
			return `border:1px solid #F0C531;
                    border-left:5px solid #F0C531;
                    > span{
                        color: white;
                        font-size: 20px;
                    }
	`;
		default:
			return `border:1px solid #536DFE;
                    border-left:5px solid #536DFE;
                    > span{
                        color: white;
                        font-size: 20px;
                    }
	`;
	}
};

const Toast = styled.div<ToastProps>`
	transition: all ease 0.4s;
	background: ${colors.White};
	color: ${colors.Black};
	font-size: 13px;
	padding: 22px 22px 22px 25px;
	min-width: 300px;
	max-width: 800px;
	height: auto;
	display: none;
	align-items: center;
	border-radius: 4px;
	position: fixed;
	z-index: 999999;
	box-shadow: 0px 0px 10px #b1aeae;
	transition: ease-in all 0.4s;
	right: ${({ right }) => right};
	left: ${({ left }) => left};
	top: ${({ top }) => top};
	bottom: ${({ bottom }) => bottom};
	${({ show }) => show && `display: inline-flex;`}
	${({ iconToast }) => iconToast && `padding-left:75px;`}
	@media screen and (max-width: 500px) {
		min-width: auto;
		max-width: calc(100% - 40px);
	}

	> span {
		position: absolute;
		font-size: 33px;
		left: 0;
		top: 0;
		height: 100%;
		display: flex;
		width: 75px;
		justify-content: center;
		align-items: center;
	}
	p {
		font-size: 14px;
		color: ${colors.White};
		font-family: 'RubikRegular';
		line-height: 20px;
	}
	button {
		background: transparent !important;
		padding: 0px;
		width: 20px;
		font-size: 8px;
		height: 20px;
		position: absolute;
		right: 5px;
		top: 5px;
		color: ${colors.White};
		opacity: 0.6;
		&:hover {
			opacity: 1;
		}
	}
	ul {
		padding: 0;
		margin: 0;
		list-style: none;
		li {
			padding: 0;
			list-style: none;
			font-size: 14px;
			color: ${colors.White};
			font-family: 'RubikRegular';
			line-height: 20px;
			padding: 0 0 5px 0;
			&:last-child {
				padding: 0px;
			}
		}
	}
	${({ messageType }) => messageType && handleColorType(messageType)};

	${({ toastBorder }) =>
		toastBorder &&
		`button{
			color: #84829F;
		}
		p{
			color: #1A2E59;
		}
		ul{
			li{
				color: #1A2E59;
				float:left;
			}
		}
		> span{
			width: 60px;
		}
		padding: 22px 30px 22px 60px;
		box-shadow: 0px 9px 10px rgba(0, 0, 0, 0.15);
	`};
`;

export default Toast;
